import React, { useEffect } from "react";
import Navbar from "../../components/Navbar";
import Sidebar from "../../components/Sidebar";
import Filters from "../../components/Filters";
import "./style.scss";
import LineChartBasic from "../../components/Graphs/LineChartBasic";
import { useSelector, useDispatch } from "react-redux";
import { getAnalyticsCustomer } from "../../services/graphs/actions";
import { HANDLE_ERROR } from "../../services/graphs/actionTypes";
import Loader from "../../components/Loader";
import NoDataAvailable from "../../components/NoDataAvailable";
import swal from "sweetalert";
import Footer from "../../components/Footer";

const Customers = () => {
  const dispatch = useDispatch();
  const { analytics_customer, range, app, isLoading, error } = useSelector(
    ({ graphState, filtersState }) => ({
      analytics_customer: graphState.analytics_customer,
      range: filtersState.range,
      app: filtersState.app,
      isLoading: graphState.isLoading,
      error: graphState.error,
    })
  );

  const fetch = () => {
    dispatch(
      getAnalyticsCustomer({
        platform: app.platform,
        apiKey: app.apiKey,
        fromDate: range.from,
        toDate: range.to,
      })
    );
  };

  useEffect(() => {
    if (error) {
      swal("Error", error.message || "Received Error From DB", "error");
      dispatch({ type: HANDLE_ERROR, payload: null });
    }
  }, [error, dispatch]);

  // const series = [
  //   {
  //     name: "Total Users",
  //     data: [10, 41, 35, 51, 49, 62, 69, 91, 148],
  //   },
  // ];
  useEffect(() => {
    fetch();
    // eslint-disable-next-line
  }, []);
  return (
    <div className="customers_container">
      {isLoading && <Loader />}
      <Navbar />
      <Sidebar />

      <div style={{ padding: `0 20px` }}>
        <div style={{ display: "grid", gridTemplateColumns: "1fr auto" }}>
          <h1>Customers</h1>
          <h2>{app.name}</h2>
        </div>
        <Filters fetch={fetch} />
      </div>
      <div className="content">
        <div className="half_section">
          <h2>Unique Users</h2>
          {analytics_customer &&
          analytics_customer.uniqueUsersData &&
          analytics_customer.uniqueUsersData.message === "available" ? (
            <LineChartBasic
              data={[analytics_customer.uniqueUsersData.data.seriesData]}
              xaxis={analytics_customer.uniqueUsersData.data.xaxisData}
            />
          ) : (
            <NoDataAvailable title="Unique User" />
          )}
        </div>

        <div className="half_section">
          <h2>Total Users</h2>
          {analytics_customer &&
          analytics_customer.totalUsersData &&
          analytics_customer.totalUsersData.message === "available" ? (
            <LineChartBasic
              data={[analytics_customer.totalUsersData.data.seriesData]}
              xaxis={analytics_customer.totalUsersData.data.xaxisData}
            />
          ) : (
            <NoDataAvailable title="Total User" />
          )}
        </div>

        <div className="half_section">
          <h2>Returning Users</h2>
          {analytics_customer &&
          analytics_customer.returningUsersData &&
          analytics_customer.returningUsersData.message === "available" ? (
            <LineChartBasic
              data={[analytics_customer.returningUsersData.data.seriesData]}
              xaxis={analytics_customer.returningUsersData.data.xaxisData}
            />
          ) : (
            <NoDataAvailable title="Returning User" />
          )}
        </div>
        <div className="half_section">
          <h2>Average time</h2>
          {analytics_customer &&
          analytics_customer.averageUsersData &&
          analytics_customer.averageUsersData.message === "available" ? (
            <LineChartBasic
              data={analytics_customer.averageUsersData.data[0].series}
              xaxis={analytics_customer.averageUsersData.data[1].categories}
            />
          ) : (
            <NoDataAvailable title="Returning User" />
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Customers;
